import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CacheService } from 'projects/common/src/app/services';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { DashboardFacade } from 'src/app/modules/core/store/dashboard/dashboard.facade';

@Component({
  selector: 'app-widget-header-detail-material',
  templateUrl: './widget-header-detail-material.component.html',
  styleUrls: ['./widget-header-detail-material.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetHeaderDetailMaterialComponent implements OnInit {
  @Input()
  public title: string;
  @Input()
  public set detail(detail: string) {
    this.displayDetail = detail;
  }

  @Input()
  public icon: string;

  @Input()
  public isSectionHeader: boolean;

  public displayDetail: string;
  public hours: string;
  public secondTitle: string;

  constructor(private languageService: LanguageService, public dashboardFacade: DashboardFacade, public cacheService: CacheService) {}

  /**
   * On init component.
   */
  public ngOnInit(): void {
    this.secondTitle = this.cacheService.session('secondTitle');
    this.hours = !this.isSectionHeader ? this.languageService.message('hours').toLowerCase() : '';
  }
}
